import {action, observable} from "mobx";
import headerStyle from "../../../../../src/js/misc/headerStyle";
import updateHeaderWithConfig from "../utahHeader/updateHeaderWithConfig";
import headerSize from "../../../../../src/js/misc/headerSize";
import LocalStorage from "../localstorage/LocalStorage";
import menuDefault from "./menuDefault";
import IconTypes from "../../components/Configurator/Input/IconInput/IconTypes";
import ENVIRONMENT from "../../../../../src/js/misc/environment";
import UtahIDTypes from "../../components/Configurator/UtahId/UtahIDTypes";
import {objectAtPath, pathToParts} from "@dts-soldel/dts-react-common";
import packageConfig from "../../../../package.json";
import updateHeaderMenuWithConfig from "../utahHeader/updateHeaderMenuWithConfig";
import POPUP_MENU_STYLE from "../../../../../src/js/misc/popupMenuStyle";

const topBarIcon = iconName => ({
	[`${iconName}IconMenu`]: menuDefault(),
	[`${iconName}IconMenuStyle`]: POPUP_MENU_STYLE.DEFAULT,
	[`${iconName}IconOnClick`]: '',
	[`${iconName}IconOnHover`]: '',
	[`${iconName}IconPopupContent`]: '',
	[`${iconName}IconTitle`]: '',
	[`${iconName}IconShowTitle`]: null,
	[`${iconName}IconType`]: IconTypes.none,
});

const defaultState = {
	...topBarIcon('appGrid'),
	...topBarIcon('gear'),
	...topBarIcon('question'),

	headerLogoAltText: '',
	headerLogoDom: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.3 60">' +
		'<defs><style>.cls-1{fill:#007eff;}</style></defs>' +
		'<title>logo-example</title>' +
		'<g id="Layer_2" data-name="Layer 2">' +
		'<g id="Layer_1-2" data-name="Layer 1">' +
		'<path class="cls-1" d="M35,30.35,47.5,8.7h3.62A30,30,0,1,0,50.39,52H47.5Z"/>' +
		'<path class="cls-1" d="M72.7,30.35,78.85,19.7h0L72.5,8.7H51.12A30,30,0,0,1,50.39,52H72.5l6.35-11h0Z"/>' +
		'<polygon class="cls-1" points="97.3 30.35 91.15 19.7 78.85 19.7 85 30.35 78.85 41 91.15 41 97.3 30.35"/>' +
		'</g></g></svg>',
	headerLogoFunction: 'function () {\n' +
		'const e = document.createElement(\'img\');\n' +
		'e.src = \'https://cdn.utah.gov/utah-header/latest/examples/img/agency-logo.png\'; \n' +
		'return e;\n' +
		'}',
	headerLogoString: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97.3 60">' +
		'<defs><style>.cls-1{fill:#007eff;}</style></defs>' +
		'<title>logo-example</title>' +
		'<g id="Layer_2" data-name="Layer 2">' +
		'<g id="Layer_1-2" data-name="Layer 1">' +
		'<path class="cls-1" d="M35,30.35,47.5,8.7h3.62A30,30,0,1,0,50.39,52H47.5Z"/>' +
		'<path class="cls-1" d="M72.7,30.35,78.85,19.7h0L72.5,8.7H51.12A30,30,0,0,1,50.39,52H72.5l6.35-11h0Z"/>' +
		'<polygon class="cls-1" points="97.3 30.35 91.15 19.7 78.85 19.7 85 30.35 78.85 41 91.15 41 97.3 30.35"/>' +
		'</g></g></svg>',
	headerLogoUrl: 'https://cdn.utah.gov/utah-header/latest/examples/img/wide-logo.svg',
	headerLogoType: null,

	headerShortTitle: '',
	headerSize: headerSize.SMALL,
	headerStyle: headerStyle.DEFAULT,
	headerTitle: '',
	headerTitleOnClick: '',
	headerTitleURL: '',

	mainMenu: [],

	modifierClasses: [],

	onHeaderResize: '',

	searchCallback: '',
	searchIconType: IconTypes.none,
	searchOnClick: '',
	searchPlaceholder: '',
	searchShowTitle: null,
	searchTitle: '',

	utahId: {
		authCallback: '',
		customParams: '',
		customURL: '',
		environment: ENVIRONMENT.PROD,
	},
	utahIdCustom: {
		onUserClickedSignIn: 'function () {window.utahHeader.showUserAsSignedIn({first: \'Put user name here\'});}',
		onUserClickedSignOut: 'function () {window.utahHeader.showSignIn();}',
		profileURL: 'https://id.utah.gov'
	},
	utahIdType: UtahIDTypes.none,
};

export default class ConfiguratorStore {

	constructor() {
		this.reset(false);
	}

	// !!! USE THIS FUNCTION !!!
	// make all changes through this function so that lastChangedField and
	// local storage also gets updated
	/**
	 * @param fieldPath dot separated path to value location
	 * @param value new value of the path destination
	 */
	@action
	setFieldValue = (fieldPath, value) => {
		const {path, field} = pathToParts(fieldPath);
		objectAtPath(this, path)[field] = value;
		this.fieldWasUpdated(field);
	};

	@action
	fieldWasUpdated = field => {
		this.lastChangedField = field;
		this.updateWorld(true);
	};

	@action
	loadFromJSON = json => {
		const config = JSON.parse(json);
		if (config.version === packageConfig.version) {
			Object.keys(config).forEach(key => this[key] = config[key]);
		}
	};

	@action
	reset = (saveToStorage = true) => {
		Object.keys(defaultState).forEach(key => this[key] = defaultState[key]);
		this.lastChangedField = null;

		this.updateWorld(saveToStorage);
	};

	updateWorld = (saveToStorage) => {
		if (saveToStorage) {
			this.storeToLocalStorage();
		}
		updateHeaderWithConfig(this);
		updateHeaderMenuWithConfig(this);
	};

	@action
	addMenuItemToMenu = menu => {
		menu.push(menuDefault().pop());
		this.updateWorld(true);
	};

	@action
	addSubMenuItemToMenuItem = menuItem => {
		menuItem.children.push(menuDefault().pop());
		this.updateWorld(true);
	};

	@action
	deleteMenuItem = menuItem => {
		// where oh where could this menu item be?: appGridIcon, gearIcon, questionIcon, mainmenu, or any of their children
		const deleteItemFromMenu = (menuItemToDelete, menu) => {
			const idx = menu.indexOf(menuItemToDelete);
			let result;
			if (idx === -1) {
				result = menu.children && menu.children.length && deleteItemFromMenu(menuItemToDelete, menu.children);
			} else {
				result = menu.splice(idx, 1);
			}
			return result || menu.filter(subMenuItem => deleteItemFromMenu(menuItemToDelete, subMenuItem.children)).length;
		};

		deleteItemFromMenu(menuItem, this.appGridIconMenu) ||
			deleteItemFromMenu(menuItem, this.gearIconMenu) ||
			deleteItemFromMenu(menuItem, this.questionIconMenu) ||
			deleteItemFromMenu(menuItem, this.mainMenu);
		this.fieldWasUpdated(null);
	};

	storeToLocalStorage = () => {
		// store in local storage
		const configToSave = Object.keys(defaultState).reduce((result, key) => {
			result[key] = this[key];
			return result;
		}, {});
		configToSave.version = packageConfig.version;
		LocalStorage.config.set(JSON.stringify(configToSave));
	};

	// !! don't set fields directly !! //
	// or else lastChangedField will not be updated and the changes won't be highlighted in the output
	@observable appGridIconMenu;
	@observable appGridIconMenuStyle;
	@observable appGridIconOnClick;
	@observable appGridIconOnHover;
	@observable appGridIconPopupContent;
	@observable appGridIconTitle;
	@observable appGridIconShowTitle;
	@observable appGridIconType;

	@observable gearIconMenu;
	@observable gearIconMenuStyle;
	@observable gearIconOnClick;
	@observable gearIconOnHover;
	@observable gearIconPopupContent;
	@observable gearIconTitle;
	@observable gearIconShowTitle;
	@observable gearIconType;

	@observable headerLogoAltText;
	@observable headerLogoDom;
	@observable headerLogoFunction;
	@observable headerLogoString;
	@observable headerLogoUrl;
	@observable headerLogoType;

	@observable headerShortTitle;
    @observable headerSize;
    @observable headerStyle;
    @observable headerTitle;
    @observable headerTitleOnClick;
    @observable headerTitleURL;

    @observable lastChangedField;

    @observable mainMenu;

    @observable modifierClasses;

    @observable onHeaderResize;

	@observable questionIconMenu;
	@observable questionIconMenuStyle;
	@observable questionIconOnClick;
	@observable questionIconOnHover;
	@observable questionIconPopupContent;
	@observable questionIconTitle;
	@observable questionIconShowTitle;
	@observable questionIconType;

    @observable searchCallback;
    @observable searchIconType;
    @observable searchOnClick;
    @observable searchPlaceholder;
    @observable searchShowTitle;
    @observable searchTitle;

    @observable utahId;
	@observable utahIdCustom;
	@observable utahIdType;
}
